import { REQUESTED_REQUEST, REQUESTED_SUCCESS, REQUESTED_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Request Action",
  result: null,
  msg: "",
  error: "",
};

const RequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case REQUESTED_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case REQUESTED_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default RequestReducer;
